import { GamesUIComponentFilterEnum, GamesUIComponentFilterType, ItemWithTranslation } from 'types/swagger';

import { ChipCheckBox } from 'components/inputs/chipCheckBox';
import { SimpleCheckbox } from 'components/inputs/simpleCheckbox';
import { ToggleCheckBox } from 'components/inputs/toggleCheckBox';

export type ConditionalCheckboxProps = ItemWithTranslation<{ label?: string }> & {
  type: GamesUIComponentFilterType;
  value: string;
  checked: boolean;
  classNameChip?: string;
  hasNoLabelToggle?: boolean;
  handleFilterChange: Function;
};

export const ConditionalCheckbox = (props: ConditionalCheckboxProps) => {
  const { type, value, label, checked, labelTrKey, classNameChip, hasNoLabelToggle, handleFilterChange } = props ?? {};

  switch (type) {
    case GamesUIComponentFilterEnum.Chip:
      return (
        <ChipCheckBox
          value={value}
          label={label}
          checked={checked}
          labelTrKey={labelTrKey}
          containerClassName={classNameChip}
          handleFilterChange={(e: HTMLInputElement) => handleFilterChange(e)}
        />
      );
    case GamesUIComponentFilterEnum.Simple:
      return (
        <SimpleCheckbox
          value={value}
          label={label}
          checked={checked}
          className={classNameChip}
          labelTrKey={labelTrKey}
          handleFilterChange={(e: HTMLInputElement) => handleFilterChange(e)}
        />
      );
    case GamesUIComponentFilterEnum.Toggle:
      return (
        <ToggleCheckBox
          value={value}
          label={label}
          checked={checked}
          className={classNameChip}
          labelTrKey={labelTrKey}
          hasNoLabel={hasNoLabelToggle}
          handleFilterChange={(e: HTMLInputElement) => handleFilterChange(e)}
        />
      );
  }

  throw new Error(`Type: "${type}" is not a valid GamesUIComponentFilterEnum option`);
};
